const STORAGE_KEY = "appVersion";
const TOAST_FLAG_KEY = "appVersionToastFor";

const LOCAL_STORAGE_WHITELIST = ["token", "back-url", "i18nextLng", "states", "statesSupps"];
const LOCAL_STORAGE_PREFIX_WHITELIST = ["hojaVisita_"];

export function parseVersion(version) {
  if (typeof version !== "string") return null;
  const parts = version.split(".").map((p) => parseInt(p, 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return null;
  return parts;
}

export function isHigherVersion(incoming, current) {
  const a = parseVersion(incoming);
  const b = parseVersion(current);
  if (!a || !b) return false;
  for (let i = 0; i < 3; i++) {
    if (a[i] > b[i]) return true;
    if (a[i] < b[i]) return false;
  }
  return false;
}

export function getStoredVersion() {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function setStoredVersion(version) {
  sessionStorage.setItem(STORAGE_KEY, version);
}

export function getToastDismissedFor() {
  return sessionStorage.getItem(TOAST_FLAG_KEY);
}

export function markToastDismissedFor(version) {
  sessionStorage.setItem(TOAST_FLAG_KEY, version);
}

function isKeyWhitelisted(key) {
  if (LOCAL_STORAGE_WHITELIST.includes(key)) return true;
  return LOCAL_STORAGE_PREFIX_WHITELIST.some((prefix) => key.startsWith(prefix));
}

export function clearSessionStoragePreservingVersion() {
  try {
    const version = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.clear();
    if (version) sessionStorage.setItem(STORAGE_KEY, version);
  } catch (e) {
    console.error("Error limpiando sessionStorage", e);
  }
}

export function cleanupStorageForNewVersion(newVersion) {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && !isKeyWhitelisted(key)) keysToRemove.push(key);
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  } catch (e) {
    console.error("Error limpiando localStorage", e);
  }

  try {
    sessionStorage.clear();
  } catch (e) {
    console.error("Error limpiando sessionStorage", e);
  }

  try {
    if (window.caches && typeof window.caches.keys === "function") {
      window.caches.keys().then((keys) => {
        keys.forEach((k) => window.caches.delete(k));
      });
    }
  } catch (e) {
    console.error("Error limpiando Cache API", e);
  }

  setStoredVersion(newVersion);
}

export function isOnLoginRoute() {
  const path = window.location.pathname || "";
  return path === "/login" || path.startsWith("/login");
}

export function isMobileDevice() {
  if (typeof window === "undefined") return false;
  const widthMobile = window.innerWidth <= 992;
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ""
  );
  return widthMobile || uaMobile;
}
